import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

function authHeaders(token) {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
}

export async function getBreakEvenConfig(token, salonId = null) {
  const res = await axios.get(`${API}/reports/break-even/config`, {
    params: salonId ? { salon_id: salonId } : undefined,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateBreakEvenConfig(payload, token, salonId = null) {
  const res = await axios.put(`${API}/reports/break-even/config`, payload, {
    params: salonId ? { salon_id: salonId } : undefined,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function runBreakEvenReport(payload, token) {
  const res = await axios.post(`${API}/reports/break-even/run`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}
